import { CompsetDeltaOptions } from '@/views/calendar-configuration/calendar-configuration.types';

export const deltaOptions: readonly CompsetDeltaOptions[] = [ 1, 3, 7, 14, 30 ];
